import { baseApi } from "./baseApi";

export const templateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTemplates: builder.query<any, void>({
      query: () => ({ url: `/api/template` }),
      providesTags: ["Template"],
    }),
  }),
});

export const { useGetTemplatesQuery } = templateApi;
